import React, { useState } from 'react';
import { createUserWithEmailAndPassword, signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../firebase-config';
import { useNavigate } from 'react-router-dom';
import { getDashboardRedirect } from '../utils/redirectAfterLogin';
import PhoneInput from '../components/PhoneInput';

function generateReferralCode() {
  // Egyszerű referral kód generátor: 8 karakter, betűk és számok
  const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
  let code = '';
  for (let i = 0; i < 8; i++) {
    code += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return code;
}

export default function AjanloiProgramAuth({ onSuccess }) {
  const navigate = useNavigate();
  const [tab, setTab] = useState('register');
  const [form, setForm] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    password: '',
    referralCode: generateReferralCode(),
  });
  const [loginForm, setLoginForm] = useState({ email: '', password: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  
  const handleChange = e => {
    const { name, value } = e.target;
    setForm(f => ({ ...f, [name]: value }));
  };
  const handleLoginChange = e => {
    const { name, value } = e.target;
    setLoginForm(f => ({ ...f, [name]: value }));
  };

  // Regisztráció
  const handleRegister = async (e) => {
    e.preventDefault();
    
    // Telefonszám validáció
    if (!form.phone || form.phone.length < 10) {
      setError('Kérjük, adjon meg egy érvényes telefonszámot!');
      return;
    }
    
    setLoading(true); setError(''); setSuccess('');
    try {
      const { doc, setDoc } = await import('firebase/firestore');
      const { db } = await import('../firebase-config');
      const userCredential = await createUserWithEmailAndPassword(auth, form.email, form.password);
      // Firestore user doc létrehozása
      await setDoc(doc(db, 'users', userCredential.user.uid), {
        firstName: form.firstName,
        lastName: form.lastName,
        email: form.email,
        phone: form.phone,
        role: 'affiliate',
        referralCode: form.referralCode,
        createdAt: new Date(),
      });
      // Backend GHL regisztráció
      const ghlPayload = {
        firstName: form.firstName,
        lastName: form.lastName,
        email: form.email,
        phone: form.phone,
        customField: [
          { id: 't38nlZ4k6JjyHiLpl2s0', value: form.referralCode }
        ],
      };
      const res = await fetch('https://createghlcontact-thmhcq452a-uc.a.run.app', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(ghlPayload),
      });
      if (!res.ok) {
        setError('GoHighLevel API hiba.');
        setLoading(false);
        return;
      }
      setSuccess('Sikeres regisztráció! Most már bejelentkezhetsz.');
      setTab('login');
    } catch (err) {
      if (err.code === 'auth/email-already-in-use') setError('Ez az email már használatban van.');
      else if (err.code === 'auth/invalid-email') setError('Érvénytelen email.');
      else if (err.code === 'auth/weak-password') setError('Túl gyenge jelszó.');
      else setError(err.message || 'Ismeretlen hiba.');
    }
    setLoading(false);
  };

  // Bejelentkezés
  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true); setError(''); setSuccess('');
    try {
      const userCredential = await signInWithEmailAndPassword(auth, loginForm.email, loginForm.password);
      setSuccess('Sikeres bejelentkezés!');
      // Jogosultság alapú redirect Firestore user doc alapján
      try {
        const { doc, getDoc } = await import('firebase/firestore');
        const { db } = await import('../firebase-config');
        const userDocRef = doc(db, 'users', userCredential.user.uid);
        const snap = await getDoc(userDocRef);
        const docData = snap.data();
        if (docData && docData.role === 'admin') {
          if (onSuccess) onSuccess();
          window.location.href = '/admin/dashboard';
        } else {
          if (onSuccess) onSuccess();
          window.location.href = '/affiliate/dashboard';
        }
      } catch (e) {
        if (onSuccess) onSuccess();
        window.location.href = '/affiliate/dashboard';
      }
    } catch (err) {
      if (err.code === 'auth/user-not-found') setError('Nincs ilyen felhasználó.');
      else if (err.code === 'auth/wrong-password') setError('Hibás jelszó.');
      else setError(err.message || 'Ismeretlen hiba.');
    }
    setLoading(false);
  };

  return (
    <div className="max-w-md w-full mx-auto bg-[#18181b] rounded-xl shadow-xl p-8 relative">
      <div className="flex mb-6 border-b border-gray-700">
        <button className={`flex-1 text-lg font-bold pb-2 ${tab === 'register' ? 'text-white border-b-2 border-red-500' : 'text-gray-400'}`} onClick={() => setTab('register')}>Regisztráció</button>
        <button className={`flex-1 text-lg font-bold pb-2 ${tab === 'login' ? 'text-white border-b-2 border-red-500' : 'text-gray-400'}`} onClick={() => setTab('login')}>Bejelentkezés</button>
      </div>
      {tab === 'register' && (
        <form onSubmit={handleRegister} className="space-y-4">
          <input type="text" name="lastName" placeholder="Vezetéknév" className="w-full bg-[#23272f] text-white rounded-md px-4 py-2" value={form.lastName} onChange={handleChange} required />
          <input type="text" name="firstName" placeholder="Keresztnév" className="w-full bg-[#23272f] text-white rounded-md px-4 py-2" value={form.firstName} onChange={handleChange} required />
          <input type="email" name="email" placeholder="Email" className="w-full bg-[#23272f] text-white rounded-md px-4 py-2" value={form.email} onChange={handleChange} required />
          <div className="w-full">
            <label className="block text-white text-sm font-medium mb-2">Telefonszám *</label>
            <div className="phone-input-dark">
              <PhoneInput
                name="phone"
                value={form.phone}
                onChange={handleChange}
                placeholder="30 123 4567"
                className="bg-[#23272f] text-white border-gray-600 focus:ring-red-500"
                required
              />
            </div>
          </div>
          <input type="password" name="password" placeholder="Jelszó" className="w-full bg-[#23272f] text-white rounded-md px-4 py-2" value={form.password} onChange={handleChange} required />
          <div className="flex items-center gap-2">
            <input type="text" name="referralCode" className="w-full bg-[#23272f] text-white rounded-md px-4 py-2" value={form.referralCode} readOnly />
            <span className="text-xs text-gray-400">Ajánlói kód (automatikus)</span>
          </div>
          <button type="submit" className="w-full bg-red-600 hover:bg-red-700 text-white font-bold py-2 rounded-md transition" disabled={loading}>{loading ? 'Feldolgozás...' : 'Regisztráció'}</button>
        </form>
      )}
      {tab === 'login' && (
        <form onSubmit={handleLogin} className="space-y-4">
          <input type="email" name="email" placeholder="Email" className="w-full bg-[#23272f] text-white rounded-md px-4 py-2" value={loginForm.email} onChange={handleLoginChange} required />
          <input type="password" name="password" placeholder="Jelszó" className="w-full bg-[#23272f] text-white rounded-md px-4 py-2" value={loginForm.password} onChange={handleLoginChange} required />
          <button type="submit" className="w-full bg-red-600 hover:bg-red-700 text-white font-bold py-2 rounded-md transition" disabled={loading}>{loading ? 'Bejelentkezés...' : 'Bejelentkezés'}</button>
        </form>
      )}
      {error && <div className="mt-4 text-red-400 text-center font-semibold">{error}</div>}
      {success && <div className="mt-4 text-green-400 text-center font-semibold">{success}</div>}
      <div className="mt-6 text-xs text-gray-400 text-center">
        Add meg vezeték- és keresztneved, e-mail címed, valamint jelszavad. Az ajánlói kód automatikusan generálódik.<br/>
        Ha már tag vagy, <button className="text-green-400 underline font-bold" onClick={() => setTab('login')}>kattints ide és jelentkezz be!</button>
      </div>
    </div>
  );
}
